import { render, staticRenderFns } from "@/extensions/shop/views/Category/Partials/ProductTransferInputField/template.pug?vue&type=template&id=5a561970&lang=pug&"
import script from "./CustomerTransferInputField.vue?vue&type=script&lang=js&"
export * from "./CustomerTransferInputField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports